import { render } from "./admin-dashboard.vue?vue&type=template&id=06b6debd&scoped=true"
import script from "./admin-dashboard.vue?vue&type=script&lang=js"
export * from "./admin-dashboard.vue?vue&type=script&lang=js"

import "./admin-dashboard.vue?vue&type=style&index=0&id=06b6debd&lang=stylus&scoped=true"

import exportComponent from "/var/www/docker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06b6debd"],['__file',"src/components/admin-dashboard/admin-dashboard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "06b6debd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('06b6debd', __exports__)) {
    api.reload('06b6debd', __exports__)
  }
  
  module.hot.accept("./admin-dashboard.vue?vue&type=template&id=06b6debd&scoped=true", () => {
    api.rerender('06b6debd', render)
  })

}


export default __exports__